import { render, staticRenderFns } from "./BudgetDAPage.vue?vue&type=template&id=182ab071&"
import script from "./BudgetDAPage.vue?vue&type=script&lang=js&"
export * from "./BudgetDAPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports